import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-3 col-sm-6 mb-25" }
const _hoisted_3 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "flex-grow-1 ms-3" }
const _hoisted_7 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_8 = { class: "col-lg-3 col-sm-6 mb-25" }
const _hoisted_9 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_10 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "flex-grow-1 ms-3" }
const _hoisted_13 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_14 = { class: "col-lg-3 col-sm-6 mb-25" }
const _hoisted_15 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_18 = { class: "flex-grow-1 ms-3" }
const _hoisted_19 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_20 = { class: "col-lg-3 col-sm-6 mb-25" }
const _hoisted_21 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_22 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_23 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_24 = { class: "flex-grow-1 ms-3" }
const _hoisted_25 = {
  class: "count fw-bold text-black d-block mb-0",
  style: {"font-size":"30px"}
}
const _hoisted_26 = { class: "col-12 mb-25" }
const _hoisted_27 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_28 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_29 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_30 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_31 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_32 = {
  key: 2,
  class: "row"
}
const _hoisted_33 = { class: "queue-card-header" }
const _hoisted_34 = { class: "fw-bold mb-1" }
const _hoisted_35 = { class: "small text-muted mb-2" }
const _hoisted_36 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_37 = { class: "badge bg-primary" }
const _hoisted_38 = { class: "queue-card-body" }
const _hoisted_39 = { class: "col-12" }
const _hoisted_40 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_41 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_42 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_43 = { class: "table-responsive" }
const _hoisted_44 = { class: "table align-middle mb-0" }
const _hoisted_45 = { class: "fw-medium" }
const _hoisted_46 = ["innerHTML"]
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = {
  key: 1,
  class: "btn btn-secondary btn-sm disabled"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-folder text-primary",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.stats.totalFiles), 1),
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Files assignées", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-file text-warning",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.stats.pendingTasks), 1),
              _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Dossiers en attente", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-check text-success",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.stats.completedTasks), 1),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "Dossiers traités", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "flex-shrink-0" }, [
              _createElementVNode("i", {
                class: "flaticon-time text-info",
                style: {"font-size":"40px"}
              })
            ], -1)),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.stats.inProgressTasks), 1),
              _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-body-tertiary fs-12 fw-medium mb-0" }, "En cours", -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("div", _hoisted_28, [
          _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Mes Files de Validation", -1)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadAgentData && _ctx.loadAgentData(...args))),
            class: "btn btn-primary btn-sm"
          }, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
            _createTextVNode(" Actualiser ", -1)
          ]))])
        ]),
        _createElementVNode("div", _hoisted_29, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                ], -1)
              ]))]))
            : (_ctx.assignedQueues.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("i", {
                    class: "flaticon-folder-open text-muted",
                    style: {"font-size":"48px"}
                  }, null, -1),
                  _createElementVNode("p", { class: "text-muted mt-2" }, "Aucune file assignée pour le moment", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assignedQueues, (queue) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: queue.id,
                      class: "col-md-6 col-lg-4 mb-3"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["queue-card", _ctx.getRiskCardClass(queue.maxRiskLevel)])
                      }, [
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("h6", _hoisted_34, _toDisplayString(queue.name), 1),
                          _createElementVNode("p", _hoisted_35, _toDisplayString(queue.code), 1),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", _ctx.getRiskBadgeClass(queue.maxRiskLevel)])
                            }, _toDisplayString(_ctx.getRiskLabel(queue.maxRiskLevel)), 3),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.getBescsCount(queue.id)) + " dossiers ", 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createVNode(_component_router_link, {
                            to: { name: 'AgentFilesPage', query: { queueId: queue.id } },
                            class: "btn btn-primary btn-sm w-100"
                          }, {
                            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                              _createElementVNode("i", { class: "flaticon-folder-open me-1" }, null, -1),
                              _createTextVNode(" Voir les dossiers ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ], 2)
                    ]))
                  }), 128))
                ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _cache[15] || (_cache[15] = _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Tâches Récentes", -1)),
          _createVNode(_component_router_link, {
            to: "/agent-files",
            class: "btn btn-outline-primary btn-sm"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode(" Voir toutes les tâches ", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("table", _hoisted_44, [
              _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Référence BESC"),
                  _createElementVNode("th", null, "File"),
                  _createElementVNode("th", null, "Statut"),
                  _createElementVNode("th", null, "Priorité"),
                  _createElementVNode("th", null, "Date limite"),
                  _createElementVNode("th", null, "Actions")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recentTasks, (task) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: task.id
                  }, [
                    _createElementVNode("td", _hoisted_45, _toDisplayString(task.validationTask.besc?.refbesc), 1),
                    _createElementVNode("td", null, _toDisplayString(task.validationTask.validationqueue?.name), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.getStatusBadge(task.result)
                      }, null, 8, _hoisted_46)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.getPriorityBadge(task.validationTask.priority)
                      }, null, 8, _hoisted_47)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.format_date(task.validationTask.sla_due_at)), 1),
                    _createElementVNode("td", null, [
                      (task.validationTask.besc?.id)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: { name: 'ViewBesc', params: { id: task.validationTask.besc.id } },
                            class: "btn btn-primary btn-sm",
                            title: "Voir le dossier"
                          }, {
                            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("i", { class: "flaticon-eye" }, null, -1)
                            ]))]),
                            _: 1
                          }, 8, ["to"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_48, [...(_cache[17] || (_cache[17] = [
                            _createElementVNode("i", { class: "flaticon-eye" }, null, -1)
                          ]))]))
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}